/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Thank_YouInputs */

const vi_receipt_thank_you = /** @type {(inputs: Receipt_Thank_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xin cảm ơn quý khách và hẹn gặp lại!`)
};

/**

* @param {Receipt_Thank_YouInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_thank_you = /** @type {((inputs?: Receipt_Thank_YouInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Thank_YouInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_thank_you(inputs)
});